export default __webpack_public_path__ + "static/media/serv_consultoria.2bad92bd.jpg";